import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class UnsavedChangesService {
  private unsavedChanges = false
  // private isNavigationBlocked = false

  /* istanbul ignore next */
  setUnsavedChangesStatus(status: boolean): void {
    this.unsavedChanges = status
  }

  /* istanbul ignore next */
  hasUnsavedChanges(): boolean {
    return this.unsavedChanges
  }
}
